import React, { useCallback } from "react";
import styled from "styled-components";

import { mdiCheck, mdiClose } from "@mdi/js";
import { Svg } from "./Svg";

const OutputStyle = styled.div`
    width: 100%;
    white-space: nowrap;
    text-align: ${props => props.$textAlign};
`;

const df = new Intl.DateTimeFormat("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
const defaultFractionDigits = 2;

export const Output = props => {

    const { value, type, symbol, textAlign = "left", fractionDigits} = props;

    const format = useCallback(() => {
        if (value === null || value === undefined) {
            return "";
        }
        const symbolize = val => (symbol ? val + " " + symbol : val);
        if (type === "date") {
            return symbolize(df.format(value));
        } else if (type === "decimal") {
            let actualFractionDigits = defaultFractionDigits;
            if(fractionDigits !== undefined && fractionDigits !== null) {
                actualFractionDigits = fractionDigits;
            }
            const nf = new Intl.NumberFormat("de-DE", { minimumFractionDigits: actualFractionDigits, maximumFractionDigits: actualFractionDigits, useGrouping: false });
            return symbolize(nf.format(value));
        } else if (type === "boolean") {
            return <Svg path={value ? mdiCheck : mdiClose} size="16" />;
        }
        return symbolize(value);
    }, [value]);

    return (
        <OutputStyle $textAlign={textAlign}>
            {format()}
        </OutputStyle>
    );
};